"use client";

// Fehlerzustand: ein Satz, ein Knopf. Die technische Meldung bleibt
// auf dem Server (Next ersetzt sie im Produktionsbau ohnehin).

import { useEffect } from "react";
import { AlertTriangle } from "lucide-react";
import { Button, EmptyState } from "@/components/ui";

export default function EinstellungenFehler({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <EmptyState
      icon={AlertTriangle}
      title="Die Einstellungen ließen sich nicht laden"
      description={error.digest ? `Fehlerkennung ${error.digest} — bitte bei der Ansichtssache melden, wenn es bleibt.` : "Bitte noch einmal versuchen."}
      action={<Button onClick={reset}>Noch einmal</Button>}
    />
  );
}
